import { createRouter, createWebHashHistory } from 'vue-router'
import Login from '@/pages/login/Login.vue'
import Home from '@/pages/home/Home.vue'
import HomeInfo from '@/pages/home/HomeInfo.vue'

import Nopomission from '@/pages/pomission/Nopomission.vue'

import StoreInfoManager from '@/pages/store/StoreInfoManager.vue'
import StorePicManager from '@/pages/store/StorePicManager.vue'

import RoomManager from '@/pages/room/RoomManager.vue'
import OrderManager from '@/pages/order/OrderManager.vue'
import EmployeeManager from '@/pages/employee/EmployeeManager.vue'
import TransactionDetail from '@/pages/account/TransactionDetail.vue'



import Store from '../tools/Storage'

const Router = createRouter({
    history:createWebHashHistory(),
    routes:[
        {
            path:'/login',
            component:Login,
            name:"login"
        },
        {
            path:'/nopomission',
            component:Nopomission,
            name:"nopomission",
        },{
            path:'/home',
            component:Home,
            name:"home",
            children:[
                {
                    path:'homeinfo',
                    component:HomeInfo,
                    name:"homeinfo"
                },{
                    path:'storeinfomanager',
                    component:StoreInfoManager,
                    name:"storeinfomanager"
                },{
                    path:'storepicmanager',
                    component:StorePicManager,
                    name:"storepicmanager"
                },{
                    path:'roommanager',
                    component:RoomManager,
                    name:"roommanager"
                },{
                    path:'ordermanager',
                    component:OrderManager,
                    name:"ordermanager"
                },{
                    path:'employeemanager',
                    component:EmployeeManager,
                    name:"employeemanager"
                },{
                    path:'transactiondetail',
                    component:TransactionDetail,
                    name:"transactiondetail"
                }],
            redirect:'/home/homeinfo'
        }
    ]
})
export function isinmenu(name){
    const menulist=JSON.parse(sessionStorage.getItem("routemenuList"));
    let isinmenu=false;
    if(menulist==undefined||menulist==null){
        return false;
    }
    for (let i = 0; i < menulist.length; i++) {
           const item=menulist[i]
           if(name==item.pageName){
                isinmenu=true;
                return isinmenu
           }
        
    }
    return isinmenu; 
}
Router.beforeEach((from)=>{
    let isLogin=Store.getters.isLogin;
    if(isLogin&&(from.name==''||from.name==undefined)){
        return {name:'home'}
    }else if(isLogin&&from.name=='login'){
        return true;
    }else if(isLogin&&(from.name!='login'||from.name!=undefined)){
        if(from.name=='home'||from.name=='nopomission'||from.name=='homeinfo'||isinmenu(from.name)){
            return true;
        }else{
            return {name:'nopomission'}
        }
        
        
    }else if(from.name=="login"){
        return true;
    }else{
         return {name:'login'}
    }
})

export default Router;